import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CheckboxComponent } from '@app/shared/components/checkbox/checkbox.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationMode } from '@services/image.service';
import { Subscription } from 'rxjs';
import { ModelModel } from './../../../../_models/api-models/model';
import { ModelGroupModel } from './../../../../_models/model-group';
import { ModelSizeModel } from './../../../../_models/model-size';
import { DataApiService } from './../../../../_services/data-api.service';
import { EnduserDisplayService } from './../../../../_services/enduserdisplay.service';

@Component({
	selector: 'customizer-forms-fixtures',
	templateUrl: './customizer-forms-fixtures.component.html',
	styleUrls: ['./customizer-forms-fixtures.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CheckboxComponent, TranslatePipe]
})
export class CustomizerFormsFixturesComponent implements OnInit, OnChanges, OnDestroy {

	@Input() hasFixtures: boolean;
	@Input() hasForms: boolean;
	@Input() modelGroup?: ModelGroupModel | null;
	@Input() modelSize?: ModelSizeModel;
	@Input() model?: ModelModel | null;

	@Input() bagmode = false;

	@Input() isOrderConfirmation: boolean | null;
	@Input() configurationMode: ConfigurationMode = ConfigurationMode.undefined;
	@Output() modelSizeChange: EventEmitter<ModelSizeModel> = new EventEmitter<ModelSizeModel>();
	@Output() hasFormsChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() hasFixturesChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public modelSizes: Array<ModelSizeModel> = [];
	private enduserDisplayServiceSubscription: Subscription;

	constructor(private apiService: DataApiService, private enduserDisplayService: EnduserDisplayService) { }

	async ngOnInit() {
		if (this.configurationMode == ConfigurationMode.enduser) {
			await this.init(false);
		}
		else if (this.configurationMode == ConfigurationMode.display) {
			await this.init(true);
		}
		else {
			this.enduserDisplayServiceSubscription = this.enduserDisplayService.enduserDisplayChangedObservable().subscribe(async x => {
				await this.init(x === ConfigurationMode.display);
			});
		}
	}

	async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['modelSize'] && !changes['modelSize'].firstChange
			&& (<ModelSizeModel>changes['modelSize'].previousValue)?.Id !== (<ModelSizeModel>changes['modelSize'].currentValue)?.Id) {
			this.init(this.enduserDisplayService.IsDisplay());
		}
	}

	ngOnDestroy(): void {
		if (this.enduserDisplayServiceSubscription && !this.enduserDisplayServiceSubscription.closed) {
			this.enduserDisplayServiceSubscription.unsubscribe();
		}
	}

	async init(isDisplay: boolean) {
		const sizes = await this.apiService.getSizes(this.modelGroup?.ProductLineUuid, this.modelGroup?.Uuid, this.model?.Uuid);

		if (this.modelGroup?.IsRimless && !isDisplay && (this.modelGroup.HasFixtures || this.modelGroup.HasForms)) {
			this.modelSizes = sizes?.sortBy(x => x.Code) ?? [];
		} else {
			if (this.modelSize) {
				this.modelSizes = sizes?.filter(x => x.Uuid === this.modelSize?.Uuid) ?? [];
			}
		}
	}

	public setForms(modelsize: ModelSizeModel, hasForms: boolean) {
		if (modelsize.Id != this.modelSize?.Id) {
			this.modelSizeChange.emit(modelsize);
		}
		this.hasFormsChange.emit(hasForms);
	}

	public setFixtures(modelsize: ModelSizeModel, hasForms: boolean) {
		if (modelsize.Id != this.modelSize?.Id) {
			this.modelSizeChange.emit(modelsize);
		}
		this.hasFixturesChange.emit(hasForms);
	}

	public disabled(requiredBool: boolean, ms: ModelSizeModel): boolean {
		const disabled = (requiredBool && ms.Uuid !== this.modelSize?.Uuid) || this.isOrderConfirmation === true;
		return disabled;
	}

}
